import Provider from "./Provider-Api";
import CheckApi from "./check-api";

export const addressGetCountry = async (token) => {
  CheckApi('getCountry', token)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getCountry",
    token
  });
  CheckApi('dataRes-getCountry', dataRes)
  return dataRes;
};

// export const addressGetNationality = async (token) => {
//   CheckApi('getNationality',token)
//   // const dataRes = await 
//   const dataRes = await Provider({
//     type: "POST",
//     url: "/address/getNationality",
//     token
//   });
//   CheckApi('dataRes-getNationality', dataRes)
//   return dataRes;
// };

export const addressGetProvince = async (token) => {
  CheckApi('getProvince', token)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getProvince",
    token
  });
  CheckApi('dataRes-getProvince', dataRes)
  return dataRes;
};

export const addressGetDistrict = async (data, token) => {
  CheckApi('getDistrict', data)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getDistrict",
    data,
    token
  });
  CheckApi('dataRes-getDistrict', dataRes)
  return dataRes;
};

export const addressGetSubdistrict = async (data, token) => {
  CheckApi('getSubdistrict', data)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getSubdistrict",
    data,
    token
  });
  CheckApi('dataRes-getSubdistrict', dataRes)
  return dataRes;
};

export const addressGetNationality = async (token) => {
  CheckApi('getNationality', token)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getNationality",
    token
  });
  CheckApi('dataRes-getNationality', dataRes)
  return dataRes;
};

export const addressGetNameTitle = async (token) => {
  CheckApi('getNameTitle', token)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getNameTitle",
    token
  });
  CheckApi('dataRes-getNameTitle', dataRes)
  return dataRes;
};

export const addressGetMalina = async (token) => {
  CheckApi('getMalina', token)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getMalina",
    token
  });
  CheckApi('dataRes-getMalina', dataRes)
  return dataRes;
};

export const addressGetDestination = async (token) => {
  CheckApi('getDestination', token)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getDestination",
    token
  });
  CheckApi('dataRes-getDestination', dataRes)
  return dataRes;
};

export const addressGetExpenseTypen = async (token) => {
  CheckApi('getExpenseType', token)
  // const dataRes = await 
  const dataRes = await Provider({
    type: "POST",
    url: "/address/getExpenseType",
    token
  });
  CheckApi('dataRes-getExpenseType', dataRes)
  return dataRes;
};